var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isDefaultLogin == true)?_c('reset-password-defualt'):_vm._e(),(_vm.isDefaultLogin == false)?_c('reset-password-reseller'):_vm._e(),(_vm.isCustomer)?_c('reset-password-customer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }